import { render, staticRenderFns } from "./default-cart-item.vue?vue&type=template&id=447e32b4&scoped=true"
import script from "./default-cart-item.vue?vue&type=script&lang=js"
export * from "./default-cart-item.vue?vue&type=script&lang=js"
import style0 from "./default-cart-item.vue?vue&type=style&index=0&id=447e32b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447e32b4",
  null
  
)

export default component.exports